module.exports = __webpack_public_path__ + "img/0499e6_c569ebe8e65d4bb08f993c982f52afa0_mv2.cea7269a.webp";